import { Component, Input } from '@angular/core';

@Component({
  selector: 'caption-label-box',
  templateUrl: './caption-label-box.component.html',
  styleUrls: ['./caption-label-box.component.scss']
})
export class CaptionLabelBoxComponent {
  @Input() header: string;
  @Input() label: string;
  @Input() link?: string;
}
